<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <h3 class="mb-3">Informuojami asmenys</h3>

    <reg-prasymas-informavimas-asmenys :readonly="isReadonlyForm" />

    <template v-if="showPranesimai">
      <h3 class="mt-5 mb-3">Išsiųsti pranešimai</h3>

      <v-data-table
        class="mb-4"
        :loading="loading"
        :headers="filteredHeaders"
        :items="filterPranesimai"
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :hide-default-footer="hideFooter"
        :items-per-page="pageSize"
      >
        <template #top>
          <v-toolbar flat
            ><v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label=""
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
        <template #[`item.zug_busena`]="{ item }">
          <el-prasymas-busena :busena="item.zug_busena" />
        </template>
        <template #[`item.bylos`]="{ item }">
          <div class="nowrap">
            <el-byla
              v-for="byla in item.bylos"
              :key="byla.byl_id"
              :byla="byla"
            />
          </div>
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="nowrap" v-if="item.zug_busena != 'Suformuotas'">
            <el-table-action :item="item" @resendItem="resendItem(item)" />
          </div>
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template slot="loading">
          kraunasi
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </template>

    <modal-prasymas-informavimas
      resend
      v-model="showResend"
      :item="modalResendItem"
      :readonly="isReadonly"
      :rusis="modalResendRusis"
      @confirmResend="confirmResend"
    />

    <v-footer class="form-footer" v-if="!isReadonly">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="checkErrorsClick()"
        :loading="loadingTikrinti"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import checkErrors from '@/mixins/checkErrors'
import ModalPrasymasInformavimas from '../modals/ModalPrasymasInformavimas'
import RegPrasymasInformavimasAsmenys from './RegPrasymasInformavimasAsmenys'

export default {
  name: 'RegPrasymasInformavimas',
  components: {
    ModalPrasymasInformavimas,
    RegPrasymasInformavimasAsmenys,
  },
  mixins: [userRole, busena, checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      pranesimai: [],
      search: null,

      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      showResend: false,
      modalResendItem: {},
      modalResendRusis: null,
    }
  },
  computed: {
    ...mapGetters([
      'prasymasID',
      'prasymasTipas',
      'prasymasBusena',
      'prasymasReadonly',
    ]),
    headers() {
      return [
        {
          text: 'Siųsto pranešimo registracijos numeris',
          align: 'start',
          value: 'zus_numeris',
        },
        {
          text: 'Siuntimo data ir laikas',
          align: 'start',
          value: 'zus_busenos_data',
        },
        {
          text: 'Adresatas',
          align: 'start',
          value: 'zus_adresatas',
        },
        {
          text: 'Adresato el. paštas',
          align: 'start',
          value: 'zus_adresato_el_pastas_text',
        },
        {
          text: 'Siųsto pranešimo rūšis',
          align: 'start',
          value: 'zus_dokumento_rusis',
        },
        {
          text: 'Siųsto dokumento būsena',
          align: 'start',
          value: 'zus_busena',
        },
        {
          text: 'Dokumentai',
          align: 'center',
          value: 'bylos',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
          hide: !this.roleRG,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filterPranesimai() {
      return this.pranesimai.map(item => {
        item.zus_adresato_el_pastas_text = item.zus_adresato_el_pastas
          ? item.zus_adresato_el_pastas.replaceAll(',', ', ')
          : ''
        item.bylos = item.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `ntrpaslaugos/byla/${byla.byl_id}/${byla.byl_hash}/content`,
            pranesimas_numeris: item.zus_numeris,
          }
        })

        item.canResend = true
        return item
      })
    },
    hideFooter() {
      return this.filterPranesimai.length <= 10
    },
    showPranesimai() {
      return (
        this.isIregistruotas ||
        this.isGrazintas ||
        this.isAtmestas ||
        this.isNepatikslintas
      )
    },
    isReadonly() {
      return this.readonly
    },
    isReadonlyForm() {
      return this.readonlyForm
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.loadingTikrinti = true

      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/issiusti-pranesimai`)
        .then(res => {
          this.pranesimai = res.data.pranesimai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.loadingTikrinti = false
          this.pageloading = false
        })
    },
    resendItem(item) {
      this.modalResendItem = Object.assign(
        {},
        {
          zus_id: item.zus_id,
          asm_pavadinimas: item.zus_adresatas,
          sasm_el_pastai: item.zus_adresato_el_pastas
            ? item.zus_adresato_el_pastas.split(',')
            : [],
        }
      )
      this.modalResendRusis = item.zus_dokumento_rusis_kodas
      this.showResend = true
    },
    confirmResend() {
      this.getData()
    },
    checkErrorsClick() {
      this.loadingTikrinti = true
      this.checkNtrErrors()
    },
  },
}
</script>
